/**
 * AskAiNeedsKey — the one line drawn where an AI control would be when no model
 * is known to answer (lib/ai/aiAvailability, useAiControl): that no model is
 * connected, and how one gets connected. Drawn instead of a button that would
 * fail after the click (build contract §2.8). Every screen that leaves out an AI
 * control for want of a model draws this, so the words and the link are said
 * one way, for everyone.
 */

import { Link } from 'react-router-dom';

/** The whole line, word for word. The part in {@link MY_CONNECTORS_LABEL} is drawn as a link. */
export const ASK_AI_NEEDS_KEY_TEXT =
  'No AI model is connected yet. Add your own ChatGPT or Claude key in Settings → My Connectors, or ask Peak Priorities to connect one for the workspace.';
/** The words in {@link ASK_AI_NEEDS_KEY_TEXT} that link to the My Connectors page. */
export const MY_CONNECTORS_LABEL = 'Settings → My Connectors';
/** Settings → My Account → My Connectors, where a person adds their own key. */
export const MY_CONNECTORS_PATH = '/prioritization/settings/my-connectors';

const [BEFORE_LINK, AFTER_LINK] = ASK_AI_NEEDS_KEY_TEXT.split(MY_CONNECTORS_LABEL);

export function AskAiNeedsKey({ className = '' }: { className?: string }) {
  return (
    <p className={`text-[11px] leading-4 text-[var(--text-ter)] ${className}`} data-testid="ask-ai-needs-key">
      {BEFORE_LINK}
      <Link to={MY_CONNECTORS_PATH} className="underline hover:text-[var(--text-sec)]">
        {MY_CONNECTORS_LABEL}
      </Link>
      {AFTER_LINK}
    </p>
  );
}
